import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import Assets from "@hydrologiq/assets/views/Assets"
import { Provider } from "react-redux"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import store from "./state/store"
import AssetMonitoring from "./components/AssetMonitoring"

import { RouteProvider, Section } from "@hydrologiq/shared/providers/RouteProvider"
import SharedProviders from "@hydrologiq/shared/providers/Providers"

import AssetHistory from "./components/AssetHistory"
import ScrollToTop from "@hydrologiq/shared/ScrollToTop"
import AssetsSelection from "./components/selection/AssetsSelection"
import Asset from "./views/Asset"
import { useGetCopyHomeRoute } from "@hydrologiq/shared/providers/helpers/useCopy"
import AssetUsage from "./views/AssetUsage"
import AssetReport from "./views/AssetReport"
import AssetMaintenance from "./views/AssetMaintenance"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"
import AssetForecast from "./views/AssetForecast"
import AssetAlerts from "./views/AssetAlerts"
import Settings from "./views/Settings"

export function Routing(props: { basePath?: string; user?: DashboardUser; container?: React.RefObject<HTMLElement> }) {
  let { path: sectionPath = "assets" } = useGetCopyHomeRoute()
  const { basePath = sectionPath, user, container } = props
  const assetForecastFeatureEnabled = useGetFeature("asset_forecast")
  const servicingEnabled = useGetFeature("servicing")
  const hideReports = useGetFeature("hide_reports_asset")
  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {!basePath && <Route path={sectionPath} element={<Navigate to={"/"} />} />}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.ASSETS}>
              <SharedProviders container={container} user={user}>
                <AssetsSelection />
              </SharedProviders>
            </RouteProvider>
          }
        >
          <Route index element={<Assets />} />
          <Route path=":assetId" element={<Outlet />}>
            <Route index element={<Asset />} />
            {assetForecastFeatureEnabled && <Route path="forecast" element={<AssetForecast />} />}
            <Route path="monitoring" element={<AssetMonitoring />} />
            <Route path="alerts" element={<AssetAlerts />} />
            {servicingEnabled && <Route path="history" element={<AssetHistory />} />}
            <Route path="maintenance" element={<AssetMaintenance />} />
            {!hideReports && <Route path="reporting" element={<AssetReport />} />}
            <Route path="download" element={<AssetUsage />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Route>
      </Routes>
    </Provider>
  )
}

export default Routing
